import classNames from './job-board-menu.module.css';
import {useTranslation} from 'react-i18next';
import {useHistory} from 'react-router-dom';
import ProfilePicture from './profileImageUpload';
import {base64StringtoFile, until} from 'helpers/helpers';
import {postAPI} from 'data.api';
import {AuthContext} from 'contexts/auth.context';
import {useContext} from 'react';
import toastService from 'components/Toasts/toast-service';
import reactQueryKeys from 'helpers/reactQueryKeys';
import {useQueryClient} from 'react-query';
import {uploadProfilePic} from 'api_urls';
interface JobBoardMenuProps {
  active?: string;
  profilePic?: string;
  setSearchTerm?: (v) => void;
  setFilters?: (v) => void;
  setrefreshFlag?: (v) => void;
}

const JobBoardMenu = ({
  active,
  profilePic,
  setSearchTerm,
  setFilters,
  setrefreshFlag,
}: JobBoardMenuProps) => {
  const {t} = useTranslation();
  const history = useHistory();
  const queryClient = useQueryClient();
  const authProvider = useContext(AuthContext);
  const {userDetails, loadUserDetails} = authProvider;
  async function handleRedirect(type) {
    if (type === 'jobboard')
      history.push({
        pathname: `/internal/jobboard`,
      });
    else if (type === 'AppliedList')
      history.push({
        pathname: `/jobboard/applied`,
      });
    else
      history.push({
        pathname: `/jobboard/profile`,
      });
  }

  async function submitProfileImage({imageData64, selectedFileName}) {
    if (imageData64 && selectedFileName) {
      const myNewCroppedFile = base64StringtoFile(
        imageData64,
        selectedFileName,
      );
      const formData = new FormData();
      formData.append('file_avatar', myNewCroppedFile);
      const [err, res] = await until(postAPI(formData, uploadProfilePic));
      if (err) {
        return toastService.error({msg: err.message});
      }
      if (res?.data) {
        loadUserDetails();
        return toastService.success({msg: res.message});
      }
    }
  }

  return (
    <>
      <div className={classNames['profile-container-parent']}>
        <div className={classNames['profile-container']}>
          <ProfilePicture
            submitProfileImage={submitProfileImage}
            profilePic={profilePic ? profilePic : userDetails?.profile_pic}
            module={active}
          />
        </div>
        <div className={classNames['profile-container-parent']}>
          <div
            className={`${
              active === 'search-job' ? classNames['menu-item-active'] : ''
            } ${classNames['menu-item']}`}
            onClick={() => {
              handleRedirect('jobboard');
              setSearchTerm('');
              setFilters({});
              setrefreshFlag(new Date().getTime());
              queryClient.invalidateQueries(reactQueryKeys.ALL_POSTED_JOB_LIST);
            }}
          >
            {t('Side_Menu_Search Job')}
          </div>
          <div
            className={`${
              active === 'application' ? classNames['menu-item-active'] : ''
            } ${classNames['menu-item']}`}
            onClick={() => handleRedirect('AppliedList')}
          >
            {t('Job_Board_Menu_Applications')}
          </div>
          <div
            className={`${
              active === 'profile' ? classNames['menu-item-active'] : ''
            } ${classNames['menu-item']}`}
            onClick={() => handleRedirect('profile')}
          >
            {t('Job_Board_Menu_Profile')}
          </div>
        </div>
      </div>
    </>
  );
};

export default JobBoardMenu;
